import { GenIcon } from 'react-icons';
export const MdCurrencyFlagEur = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_26969)' },
            child: [
                {
                    tag: 'rect',
                    attr: {
                        width: '24',
                        height: '24',
                        fill: '#006BAB',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M5.41971 15.639L5.15435 14.8205L4.89055 15.6406H4.0353L4.72777 16.1464L4.46397 16.9628L5.15592 16.457L5.84839 16.9628L5.58302 16.1443L6.27339 15.6385L5.41971 15.639ZM4.12166 12.6119L4.8157 13.1162L4.54876 12.2998L5.23914 11.7918L4.38389 11.7934L4.11695 10.977L3.85525 11.7955L3 11.7992L3.69404 12.3019L3.43181 13.1198L4.12166 12.6119ZM16.1983 18.594L15.936 17.7755L15.6691 18.5919L14.8154 18.5882L15.5058 19.0956L15.2373 19.9141L15.9313 19.4099L16.6217 19.9178L16.36 19.0998L17.054 18.5956L16.1983 18.594ZM8.33771 18.6135L8.07392 17.7971L7.81012 18.6151L6.95487 18.6166L7.64734 19.1209L7.38511 19.9394L8.07549 19.432L8.76743 19.9362L8.50206 19.1198L9.19244 18.614L8.33771 18.6135ZM12.3329 19.6741L12.0675 18.8577L11.8037 19.6778H10.95L11.6404 20.1836L11.3803 21L12.0707 20.4942L12.7647 20.9968L12.4978 20.1805L13.1866 19.6746L12.3329 19.6741ZM19.111 15.6437L18.8457 14.8274L18.5819 15.6437L17.7266 15.6453L18.4206 16.1496L18.1568 16.9681L18.8472 16.4622L19.5397 16.9665L19.2743 16.1501L19.9668 15.6427L19.111 15.6437ZM21 11.7813L20.1447 11.7776L19.8846 10.9591L19.6156 11.7755L18.7603 11.7718L19.4507 12.2792L19.1838 13.0956L19.8773 12.5929L20.5677 13.1025L20.306 12.2824L21 11.7802V11.7813ZM18.0909 9.08053L18.7813 8.5747L19.4737 9.08053L19.2084 8.26415L19.9003 7.75621L19.0451 7.75779L18.7797 6.93771L18.5159 7.75779H17.6607L18.3547 8.26362L18.0909 9.08053ZM15.9816 4.08378L15.7193 4.90017L14.8641 4.90175L15.5581 5.406L15.2943 6.22449L15.9847 5.72024L16.6767 6.22291L16.4113 5.40653L17.1017 4.89911L16.248 4.90069L15.9816 4.08378ZM4.40273 9.14317L5.09311 8.63734L5.78505 9.14159L5.51969 8.3231L6.21163 7.81726H5.35638L5.09101 7.00088L4.82722 7.81884L3.97197 7.82042L4.66391 8.32468L4.40169 9.14317H4.40273ZM7.31916 6.21239L8.01111 5.70655L8.70148 6.21081L8.43769 5.39231L9.12806 4.88648H8.27438L8.00901 4.07009L7.74522 4.88806H6.88997L7.58244 5.39231L7.31916 6.21239ZM11.3075 5.14124L12 4.63541L12.6919 5.14124L12.4281 4.32275L13.1185 3.81849H12.2633L11.9995 3L11.7357 3.81849H10.8804L11.5708 4.32275L11.3075 5.14124Z',
                        fill: '#FFD203',
                    },
                    child: [],
                },
                {
                    tag: 'circle',
                    attr: {
                        cx: '12',
                        cy: '12',
                        r: '11.5',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_26969' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
